$(document).ready(function(){
	/*-----------------------------------------------------*/
	/* Set new duration and totalcredit of DK rentetabel
	/*-----------------------------------------------------*/
	$('tr').children(".looptijd, .totaal").hide();
	$('tr').children(".0").show();
	$('select[name="maandtermijn"]').change(function(){
		var row = $(this).attr('data-bedrag');
		showClass = $(this).children('option:selected').index();
		$('tr[data-DKbedrag='+row+']:visible').children(".looptijd, .totaal").hide();
		$('tr[data-DKbedrag='+row+']:visible').children("."+showClass).show();
	});

	/*-----------------------------------------------------*/
	/* Set new duration and totalcredit of WOZ rentetabel
	/*-----------------------------------------------------*/
	$('tr').children(".looptijd, .totaal").hide();
	$('tr').children(".0").show();
	$('select[name="maandtermijn"]').change(function(){
		var row = $(this).attr('data-bedrag');
		showClass = $(this).children('option:selected').index();
		$('tr[data-WOZbedrag='+row+']').children(".looptijd, .totaal").hide();
		$('tr[data-WOZbedrag='+row+']').children("."+showClass).show();
	});

	/*-----------------------------------------------------*/
	/* Calculate new PL rentetabel on duration change
	/*-----------------------------------------------------*/
	$('select[name="looptijd-tabel"]').change(function(){
		var looptijd = $(this).val();
		var bedrag = $(this).attr("data-bedrag");
		var product = $(this).attr('data-product');
		$.ajax({
			url: "/ajax/AjaxPL/",
			data: {looptijd: looptijd, bedrag: bedrag, product: product},
			success: function(data){
				data = jQuery.parseJSON(data);
				var nominaal = data[bedrag].nominaal;
				var rente = data[bedrag].rente;
				var rentevoet = nominaal/100;
				var maandlast = (rentevoet / (1 - Math.pow((1+rentevoet), -looptijd)))*bedrag;
				var maandlast_formatted = $(maandlast).number_format(maandlast,2,',','.');
				var totaalbedrag = maandlast*looptijd;
				var totaalbedrag_formatted = $().number_format(totaalbedrag,{numberOfDecimals: 0});

				$('tr[data-PLbedrag='+bedrag+']:visible').children(':eq(2)').html('&euro; '+maandlast_formatted);
				$('tr[data-PLbedrag='+bedrag+']:visible').children(':eq(3)').html(rente);
				$('tr[data-PLbedrag='+bedrag+']:visible').children(':eq(4)').html(rente);
				$('tr[data-PLbedrag='+bedrag+']:visible').children(':eq(5)').html('&euro; '+totaalbedrag_formatted);
			}
		});
	});
});